module.exports = __webpack_public_path__ + "static/hero-map-84a418327f132908b0f2e622260e3d90.svg";